import { Component, OnInit, EventEmitter, Output, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { AliesGruaFilter } from 'app/sections/grua/Models/alies-grua-filter';
import { Observable, Subscription } from 'rxjs';


@Component({
  selector: 'app-grua-alies-filter',
  templateUrl: './grua-alies-filter.component.html',
  styleUrls: ['./grua-alies-filter.component.scss']
})
export class GruaAliesFilterComponent implements OnInit, OnDestroy {
  subscription: Subscription;
  filter: AliesGruaFilter;

  @Output() notify: EventEmitter<AliesGruaFilter> = new EventEmitter<AliesGruaFilter>();

  constructor(
    public thisDialogRef: MatDialogRef<GruaAliesFilterComponent>,
    private i18n: I18n,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.filter = data.filter;
  }

  ngOnInit() {
    this.subscription = Observable.fromEvent(document, 'keypress').subscribe((e: KeyboardEvent ) => {
      if (e.key === 'Enter') {
        this.apply();
      }
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  reset() {
    this.filter.clear();
    this.apply();
  }

  apply() {
    this.filter.updated();
    this.notify.emit(this.filter);
    this.thisDialogRef.close();
  }

  dismiss() {
    this.thisDialogRef.close();
  }

}
